import * as React from 'react';

const GoneToFar: React.FC = () => {
    
    const url = () => {
        const url = new URL(window.location.href);

        url.searchParams.set("recipePage", "1");
        url.searchParams.set("articlePage", "1");
        url.searchParams.set("ingredientPage", "1");

        return url.href;
    }

    return (
        <div className="bg-brown-50 p-4 rounded-lg ofg-bodytext">
            <h2>En feil har oppstått 😕</h2>
            <p>Oisann... nå har vi kommet litt for langt og bladd oss forbi siste treffet i søket. <a href={url()} title="Gå tilbake til første side i søket">Gå tilbake til første side</a> eller <a href="/sok" title="Søkeside">søk på nytt</a>.</p>
        </div>
    );
};

export default GoneToFar;
